module.exports = __webpack_public_path__ + "img/充电站点.8d01bd86.png";